<template>
  <button class="base-btn account-vacancies-responses__filter-select-btn" v-on="$listeners">
    <BaseSvg name="ico-filter-outlined" width="1.6rem" height="1.6rem" />
    <span>{{ value }}</span>
    <span v-if="filtersCount" class="account-vacancies-responses__filter-select-btn-count">
      {{ filtersCount }}
    </span>
    <span @click.stop="$emit('clear')">
    <BaseSvg v-if="filtersCount" name="ico-cross" width="0.8rem" height="0.8rem" />
    </span>
  </button>
</template>

<script>
export default {
  name: 'VacanciesResponsesFilterSelector',
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    filtersCount: {
      type: Number,
      required: true,
    },
  },
};
</script>
